import DashboardService from "app/components/dashboard/services/DashboardService";
import type { INavItem } from "../../../components/React/SideNavComponents/SideNav.types";
import { i18nFilter } from "app/filters/i18nFilter";
import { swSettings } from "app/common/services/swSettings";

export const navObj = ({ sharedWithMeDashboards }) => {
    const myDashboards = DashboardService.dashboards.filter((d) => !d.isSharedWithMe);
    const navList = [
        {
            title: i18nFilter()("home.page.dashboard.my"),
            name: "dashboard",
            isOpen: true,
            hidden: false,
            subItems: myDashboards as INavItem[],
        },
    ];
    const hasSharedWithMeDashboardsCached = DashboardService.dashboards.filter((d) => d.isSharedWithMe);
    if (swSettings.components.ShareDashboard.resources.CanViewSharedDashboards) {
        if (sharedWithMeDashboards.length > 0) {
            sharedWithMeDashboards.forEach(DashboardService.addDefaultsToSharedDashboard);
        }
        if (sharedWithMeDashboards.length > 0 || hasSharedWithMeDashboardsCached.length > 0) {
            navList.push({
                title: i18nFilter()("home.page.dashboard.shared.with.me"),
                name: "sharedWithMe",
                isOpen: true,
                hidden: false,
                subItems: DashboardService.dashboards.filter((d) => d.isSharedWithMe) as INavItem[],
            });
        }
    }
    navList.forEach((subNavList) => [...subNavList.subItems]);
    return { navList };
};
